module.exports = __webpack_public_path__ + "static/Wiki_Tiles_P-IN-8001HD_white-81df219ffcd65cb66e00a0a232dcc90c.png";